import { onAdvancedSearchUiDismissed, setRefinersVisibility } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(setRefinersVisibility, actionMessage => {
    getStore().refinersVisible = actionMessage.isVisible;
});

mutator(onAdvancedSearchUiDismissed, () => {
    getStore().refinersVisible = false;
});
